export default __webpack_public_path__ + "static/media/promo_00.7a1536a7.jpg";